// src/components/tableros/common/EventDetails.js
import React from 'react';
import {
  Card,
  CardHeader,
  Typography,
  Stack,
  Chip,
  Box
} from '@mui/material';

const EventDetails = ({ eventDetails, clock, timerColor, isMobile }) => {
  return (
    <Card elevation={2} sx={{ mb: 3, borderRadius: 2 }}>
      <CardHeader 
        title={
          <Typography variant="h5" fontWeight="bold">
            {eventDetails.eventName || 'No hay eventos seleccionados'}
          </Typography>
        }
        subheader={
          <Stack 
            direction={isMobile ? "column" : "row"} 
            spacing={2} 
            alignItems={isMobile ? "flex-start" : "center"}
            sx={{ mt: 1 }}
          >
            {eventDetails.event && (
              <Chip
                size="small"
                label={`Evento: ${eventDetails.event}`}
                variant="outlined"
                color="primary"
              />
            )}
            {eventDetails.round && (
              <Chip
                size="small"
                label={`Ronda: ${eventDetails.round}`}
                variant="outlined"
                color="secondary"
              />
            )}
            {eventDetails.heat && (
              <Chip
                size="small"
                label={`Heat: ${eventDetails.heat}`}
                variant="outlined"
                color="info"
              />
            )}
            {eventDetails.wind && eventDetails.wind !== 'NM' && (
              <Chip
                size="small"
                label={`Viento: ${eventDetails.wind}`}
                variant="outlined"
                color="default"
              />
            )}
            {eventDetails.participants && parseInt(eventDetails.participants) > 0 && (
              <Chip
                size="small"
                label={`Participantes: ${eventDetails.participants}`}
                variant="outlined"
                color="default"
              />
            )}
          </Stack>
        }
        action={
          <Box sx={{ p: 1 }}>
            <Typography variant="h4" color={timerColor} fontWeight="bold" sx={{ letterSpacing: '0.05em' }}>
              {clock}
            </Typography>
          </Box>
        }
      />
    </Card>
  );
};

export default EventDetails;